import React, { useRef } from 'react';
import T from 'prop-types';

import Button from './Button';

import { WebStorage } from '../../hooks/useWebStorage';
import { TRACKING_SITE_NAVIGATION } from '../../utils/web-storage-keys';

const HistoryBackButton = ({
  size,
  shape = 'square',
  variant = 'secondary',
  defaultBackPath = '/',
}) => {
  const processingRef = useRef(false);
  const { current: webStorage } = useRef(new WebStorage(window.sessionStorage));

  const onGoBack = () => {
    if (processingRef.current) return;
    processingRef.current = true;

    const navigationHistory = webStorage.getItem(TRACKING_SITE_NAVIGATION) || [];
    const [, prevHistoryEntry] = navigationHistory.slice(-2).reverse();
    const trimmedHistory = navigationHistory.slice(0, -2);

    webStorage.setItem(TRACKING_SITE_NAVIGATION, trimmedHistory);
    window.location.assign(prevHistoryEntry?.href || defaultBackPath);
  };

  return (
    <Button
      size={size}
      shape={shape}
      variant={variant}
      className="history-back-button"
      onClick={onGoBack}
    >
      <span className="hicon-arrow-left-new" />
    </Button>
  );
};

HistoryBackButton.propTypes = {
  size: T.string,
  shape: T.string,
  variant: T.string,
  defaultBackPath: T.string,
};

export default HistoryBackButton;
